import { formControlActions } from 'store/formControlSlice/formControlSlice';

export const getOrderedActiveSignals = (signalLabels = []) =>
    signalLabels
        .filter((signal) => signal.active)
        .slice()
        .sort((a, b) => {
            if (a.operation === 'PULSE') return -1;
            if (b.operation === 'PULSE') return 1;
            return 0;
        });

export const activateRelayAction = (dispatch, transactionId, relaySlotId, operation) => {
    if (!dispatch || relaySlotId === undefined || !operation) return;

    dispatch(formControlActions.activateRelay({ relaySlotId, operation }));
    if (transactionId !== undefined && transactionId !== null) {
        dispatch(formControlActions.setRelayUsed({ transactionId, relayUsed: true }));
    }
};
